import { createSlice } from '@reduxjs/toolkit';
import {getDashboardCount} from './dashboardCountApi';

const getDashboardCountSlice = createSlice({
  name: 'getDashboardCount',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardCount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDashboardCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default getDashboardCountSlice.reducer;
